import { render } from "./EditorEnterSetting.vue?vue&type=template&id=4b60ab82"
import script from "./EditorEnterSetting.vue?vue&type=script&lang=js"
export * from "./EditorEnterSetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__